"use client";
import React, { Children, FC, ReactElement, useMemo } from "react";
import Slider, { Settings } from "react-slick";

import "./externalStyles.scss";
import styles from "./main.module.scss";

type PaginationSliderType = {
  sliderSettings: Settings;
  children: ReactElement;
  className?: string;
  containerClass?: string;
  sliderRef?: React.RefObject<Slider>;
};

const PaginationSlider: FC<PaginationSliderType> = ({
  children,
  sliderSettings,
  className = "",
  containerClass = styles.sliderSlick,
  sliderRef,
}) => {
  const { infinite, slidesToShow, rows } = sliderSettings;

  const shouldHaveInfiniteSlides = useMemo(() => {
    if (!infinite) {
      return false;
    }

    return Children.count(children) > slidesToShow;
  }, [children, infinite, slidesToShow]);

  if (rows && Children.count(children) <= slidesToShow * rows) {
    return <div className={styles.bannerRow}>{children}</div>;
  }

  return (
    <div className={`slider-container ${containerClass}`}>
      <Slider className={className} {...sliderSettings} infinite={shouldHaveInfiniteSlides} ref={sliderRef}>
        {children}
      </Slider>
    </div>
  );
};

export default PaginationSlider;
